import styled from 'styled-components';

export const Wrapper = styled.article`
  animation: fadeUp 0.6s var(--ease) both;

  a {
    display: block;
  }
`;

export const Poster = styled.div`
  position: relative;
  aspect-ratio: 2 / 3;
  border-radius: var(--radius);
  overflow: hidden;
  background: var(--surface-2);
  box-shadow: var(--shadow-sm);
  transition: transform 0.45s var(--ease), box-shadow 0.45s var(--ease);

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    box-shadow: inset 0 0 0 1px rgba(23, 19, 15, 0.08);
    pointer-events: none;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: ${({ $loaded }) => ($loaded ? 1 : 0)};
    transition: opacity 0.5s, transform 0.6s var(--ease);
  }

  a:hover &,
  a:focus-visible & {
    transform: translateY(-6px) rotate(-0.6deg);
    box-shadow: var(--shadow-lg);
  }

  a:hover & img {
    transform: scale(1.04);
  }
`;

export const Fallback = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  padding: 18px;
  background: repeating-linear-gradient(
      -45deg,
      transparent 0 10px,
      rgba(23, 19, 15, 0.04) 10px 20px
    ),
    var(--surface-2);

  span {
    font-family: var(--font-display);
    font-style: italic;
    font-weight: 800;
    font-size: 56px;
    line-height: 1;
    color: var(--accent);
  }

  small {
    margin-top: 8px;
    font-size: 13px;
    color: var(--ink-2);
  }
`;

export const Badge = styled.span`
  position: absolute;
  top: 10px;
  left: 10px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 9px;
  border-radius: 999px;
  background: rgba(18, 15, 12, 0.72);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  color: #fff;
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 500;

  i {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--dot);
  }
`;

export const Meta = styled.div`
  padding: 12px 2px 0;

  h3 {
    font-size: 17px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.01em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    transition: color 0.2s;

    a:hover & {
      color: var(--accent);
    }
  }

  p {
    display: flex;
    gap: 8px;
    margin-top: 4px;
    font-family: var(--font-mono);
    font-size: 12px;
    color: var(--muted);

    span {
      padding: 0 5px;
      border: 1px solid var(--line);
      border-radius: 4px;
      font-size: 10px;
      line-height: 16px;
    }
  }
`;
